import images from "./images";

const wines = [
  {
    title: "Ah, The French Fry",
    price: "₹110",
    tags:
      "The not so 'french' fry is a box full of herbed fries topped with pico de gallo and cheese sauce"
  },
  {
    title: "Crisp Wrap",
    price: "₹170",
    tags:
      "Tortilla stuffed with refried beans, tomatoes, Jalapenos, olives, tostada, sour cream and nachos cheese."
  },
  {
    title: "The Boss Burger",
    price: "₹125",
    tags:
      "A thick veggie-bean patty sandwiched with lettuce, cheese, nachos, and fresh salsa in a bun is what makes Boss Burger 'Da Boss'."
  }
];

const cocktails = [
  {
    title: "Makhani Quesadilla",
    price: "₹225",
    tags:
      "Quesadilla filled with cottage cheese that is marinated in a creamy yet spicy red gravy along with cheese and a minty mayo dip."
  },
  {
    title: "Quesad-i-licious",
    price: "₹215",
    tags:
      "Quesadilla with a combination of cottage cheese, cheddar cheese, corn, onion, bell peppers and olives. Served with house special salsa."
  },
  {
    title: "Quesadilla goes Italian",
    price: "₹235",
    tags:
      "Savour the journey of a Quesadilla becoming Italian with cilantro pesto, diced broccoli, tomatoes, mozzarella, and a spiced mayo dip."
  },
  {
    title: "Classic Enchiladas",
    price: "₹275",
    tags:
      "Refried beans rolled in a corn tortillas, dunked in tomato-based sauce along with melted cheese and sour cream."
  },
  {
    title: "Enchilada Exotica",
    price: "₹275",
    tags:
      "Pefectly cooked exotic veggies stuffed in corn tortillas, served in a bed of dual sauce: queso and house special salsa."
  },
  {
    title: "Mexican Bowl",
    price: "₹299",
    tags:
      "Herb rice tossed with veggies, refried beans and topped with sour cream, nachos and fresh salsa."
  }
];

const awards = [
  {
    imgUrl: images.award02,
    title: "Bib Gourmond",
    subtitle: "Lorem ipsum dolor sit amet, consectetur."
  },
  {
    imgUrl: images.award01,
    title: "Rising Star",
    subtitle: "Lorem ipsum dolor sit amet, consectetur."
  },
  {
    imgUrl: images.award05,
    title: "AA Hospitality",
    subtitle: "Lorem ipsum dolor sit amet, consectetur."
  },
  {
    imgUrl: images.award03,
    title: "Outstanding Chef",
    subtitle: "Lorem ipsum dolor sit amet, consectetur."
  }
];

export default { wines, cocktails, awards };
